import { Box, Flex, Heading } from '@chakra-ui/react'
import React, { useCallback, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { useDispatch } from 'react-redux'
import ListFilmInfinity from 'src/components/Layout/ListFilmInfinity'
import { getTrendingWeekSelector } from 'src/redux/selector'
import { fetchTrendingWeekData } from 'src/services'

export const TrendingWeek = () => {
  const dispatch = useDispatch()
  let pageCount = useRef(0)
  const { value, status, page } = useSelector(getTrendingWeekSelector);
  const handleDispatchAction = useCallback(() => {
    dispatch(
      fetchTrendingWeekData({
        path: `trending/all/week`,
        params: { page: ++pageCount.current },
      })
    );
  }, [dispatch]);
    
  useEffect(() => {
    pageCount.current = 0;
    handleDispatchAction();
    window.scrollTo(0, 0);
  }, [handleDispatchAction]);
  return (
    <Box mt={'50px'}>
      <Flex mb="30px" justify="space-between" align="center">
        <Heading
          textTransform="capitalize"
          fontSize={{
            base: "xl",
            md: "2xl",
            lg: "3xl",
          }}
        >
          Top trending this week
        </Heading>
      </Flex>
      <ListFilmInfinity listFilm={value || []} status={status} pageCount={page} dispatchAction={handleDispatchAction} />
    </Box>
  )
}
